import { CHF01_IMAGES } from 'data/images/chf01/default'
import { CHM01_IMAGES } from 'data/images/chm01/default'
import { F01_IMAGES } from 'data/images/f01/default'
import { F01_MEMOJI_BROWN_IMAGES } from 'data/images/f01/memoji-brown'
import { F01_MEMOJI_BROWN_OLDER_IMAGES } from 'data/images/f01/memoji-brown-older'
import { F01_MEMOJI_OLDER_IMAGES } from 'data/images/f01/memoji-older'
import { F01_MEMOJI_PURPLE_IMAGES } from 'data/images/f01/memoji-purple'
import { F01_MEMOJI_PURPLE_OLDER_IMAGES } from 'data/images/f01/memoji-purple-older'
import { GYMF01_IMAGES } from 'data/images/gymf01/default'
import { M01_IMAGES } from 'data/images/m01/default'
import { M01_MEMOJI_DARK_IMAGES } from 'data/images/m01/memoji-dark'
import { M01_MEMOJI_OLDER_IMAGES } from 'data/images/m01/memoji-older'
import { M01_REALISTIC_IMAGES } from 'data/images/m01/realistic'
import { MILICAF01_IMAGES } from 'data/images/milicaf01/default'
import { MILICAM01_BLACK_MALE_IMAGES } from 'data/images/milicam01/black-male'
import { MILICAM01_IMAGES } from 'data/images/milicam01/default'
import { SHARED_IMAGES } from 'data/images/shared/default'
import { TCHF01_IMAGES } from 'data/images/tchf01/default'
import { TCHM01_IMAGES } from 'data/images/tchm01/default'
import { WALLPIF01_IMAGES } from 'data/images/wallpif01/default'
import { WALLPIF01_MEMOJI_BROWN_IMAGES } from 'data/images/wallpif01/memoji-brown'
import { WALLPIF01_MEMOJI_BROWN_OLDER_IMAGES } from 'data/images/wallpif01/memoji-brown-older'
import { WALLPIF01_MEMOJI_OLDER_IMAGES } from 'data/images/wallpif01/memoji-older'
import { WALLPIF01_MEMOJI_PURPLE_IMAGES } from 'data/images/wallpif01/memoji-purple'
import { WALLPIF01_MEMOJI_PURPLE_OLDER_IMAGES } from 'data/images/wallpif01/memoji-purple-older'
import type { ImagesDefinition } from 'types/images'
import type { Funnel } from 'types/state'

type FunnelVariants = Record<string, ImagesDefinition> & {
  default: ImagesDefinition
}

export const DEFAULT_IMAGE_VARIANT = 'default'

export const ALL_IMAGES = {
  chf01: { default: CHF01_IMAGES },
  chm01: { default: CHM01_IMAGES },
  f01: {
    default: F01_IMAGES,
    memojiBrown: F01_MEMOJI_BROWN_IMAGES,
    memojiBrownOlder: F01_MEMOJI_BROWN_OLDER_IMAGES,
    memojiOlder: F01_MEMOJI_OLDER_IMAGES,
    memojiPurple: F01_MEMOJI_PURPLE_IMAGES,
    memojiPurpleOlder: F01_MEMOJI_PURPLE_OLDER_IMAGES,
  },
  gymf01: { default: GYMF01_IMAGES },
  hopif01: {
    default: F01_IMAGES,
    memojiBrown: F01_MEMOJI_BROWN_IMAGES,
    memojiBrownOlder: F01_MEMOJI_BROWN_OLDER_IMAGES,
    memojiOlder: F01_MEMOJI_OLDER_IMAGES,
    memojiPurple: F01_MEMOJI_PURPLE_IMAGES,
    memojiPurpleOlder: F01_MEMOJI_PURPLE_OLDER_IMAGES,
  },
  m01: {
    default: M01_IMAGES,
    memojiDark: M01_MEMOJI_DARK_IMAGES,
    memojiOlder: M01_MEMOJI_OLDER_IMAGES,
    realistic: M01_REALISTIC_IMAGES,
  },
  milicaf01: { default: MILICAF01_IMAGES },
  milicam01: {
    default: MILICAM01_IMAGES,
    blackMale: MILICAM01_BLACK_MALE_IMAGES,
  },
  shared: { default: SHARED_IMAGES },
  tchf01: { default: TCHF01_IMAGES },
  tchm01: { default: TCHM01_IMAGES },
  wallpif01: {
    default: WALLPIF01_IMAGES,
    memojiBrown: WALLPIF01_MEMOJI_BROWN_IMAGES,
    memojiBrownOlder: WALLPIF01_MEMOJI_BROWN_OLDER_IMAGES,
    memojiOlder: WALLPIF01_MEMOJI_OLDER_IMAGES,
    memojiPurple: WALLPIF01_MEMOJI_PURPLE_IMAGES,
    memojiPurpleOlder: WALLPIF01_MEMOJI_PURPLE_OLDER_IMAGES,
  },
} as const satisfies Record<Funnel, FunnelVariants> &
  Record<string, FunnelVariants>

export type ImageVariantCoverage = 'complete' | 'partial'

export type ImageVariantMeta = {
  folder: string
  coverage: ImageVariantCoverage
}

type ImageVariantMetaMap = {
  [TCategory in keyof typeof ALL_IMAGES]: {
    [TVariant in keyof (typeof ALL_IMAGES)[TCategory]]: ImageVariantMeta
  }
}

export const IMAGE_VARIANTS: ImageVariantMetaMap = {
  chf01: { default: { folder: '/images/chf01/', coverage: 'complete' } },
  chm01: { default: { folder: '/images/chm01/', coverage: 'complete' } },
  f01: {
    default: { folder: '/images/f01/memoji/', coverage: 'complete' },
    memojiBrown: { folder: '/images/f01/memoji-brown/', coverage: 'complete' },
    memojiBrownOlder: {
      folder: '/images/f01/memoji-brown-older/',
      coverage: 'partial',
    },
    memojiOlder: { folder: '/images/f01/memoji-older/', coverage: 'partial' },
    memojiPurple: {
      folder: '/images/f01/memoji-purple/',
      coverage: 'complete',
    },
    memojiPurpleOlder: {
      folder: '/images/f01/memoji-purple-older/',
      coverage: 'partial',
    },
  },
  gymf01: {
    default: { folder: '/images/gymf01/realistic/', coverage: 'complete' },
  },
  hopif01: {
    default: { folder: '/images/f01/memoji/', coverage: 'complete' },
    memojiBrown: { folder: '/images/f01/memoji-brown/', coverage: 'complete' },
    memojiBrownOlder: {
      folder: '/images/f01/memoji-brown-older/',
      coverage: 'partial',
    },
    memojiOlder: { folder: '/images/f01/memoji-older/', coverage: 'partial' },
    memojiPurple: {
      folder: '/images/f01/memoji-purple/',
      coverage: 'complete',
    },
    memojiPurpleOlder: {
      folder: '/images/f01/memoji-purple-older/',
      coverage: 'partial',
    },
  },
  m01: {
    default: { folder: '/images/m01/memoji/', coverage: 'complete' },
    memojiDark: { folder: '/images/m01/memoji-dark/', coverage: 'partial' },
    memojiOlder: { folder: '/images/m01/memoji-older/', coverage: 'partial' },
    realistic: { folder: '/images/m01/realistic/', coverage: 'complete' },
  },
  milicaf01: {
    default: { folder: '/images/milicaf01/realistic/', coverage: 'complete' },
  },
  milicam01: {
    default: { folder: '/images/milicam01/realistic/', coverage: 'complete' },
    blackMale: {
      folder: '/images/milicam01/black-male/',
      coverage: 'partial',
    },
  },
  shared: { default: { folder: '/images/', coverage: 'complete' } },
  tchf01: { default: { folder: '/images/tchf01/', coverage: 'complete' } },
  tchm01: { default: { folder: '/images/tchm01/', coverage: 'complete' } },
  wallpif01: {
    default: { folder: '/images/wallpif01/memoji/', coverage: 'partial' },
    memojiBrown: {
      folder: '/images/wallpif01/memoji-brown/',
      coverage: 'partial',
    },
    memojiBrownOlder: {
      folder: '/images/wallpif01/memoji-brown-older/',
      coverage: 'partial',
    },
    memojiOlder: {
      folder: '/images/wallpif01/memoji-older/',
      coverage: 'partial',
    },
    memojiPurple: {
      folder: '/images/wallpif01/memoji-purple/',
      coverage: 'partial',
    },
    memojiPurpleOlder: {
      folder: '/images/wallpif01/memoji-purple-older/',
      coverage: 'partial',
    },
  },
}
